/**
 * 站内信 - 消息列表
 * 使用系统通用样式（topTab + STable + Pagination）
 * 支持状态筛选（含“全部”）、单条/批量已读、单条/批量删除
 * 标题为超链接，点击进入「消息详情」tab（通用详情布局，同 systemNotification 范式）
 */
<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<!-- 消息列表 -->
			<div v-show="activeTab === '1'">
			<!-- 搜索筛选 -->
			<lcsj-filter more-text="更多筛选" @search="search()">
			<template #actions><el-button plain size="small" icon="el-icon-check" :disabled="opParams.length === 0" @click="batchRead">批量已读</el-button><el-button plain size="small" type="danger" icon="el-icon-delete" :disabled="opParams.length === 0" @click="batchDelete">批量删除</el-button></template>
			<el-form-item label="状态：">
					<el-radio-group v-model="formInline.isRead" size="small" @change="search">
						<el-radio-button v-for="item in stateList" :key="item.value" :label="item.value">{{ item.name }}</el-radio-button>
					</el-radio-group>
				</el-form-item>
			</lcsj-filter>

			<!--列表-->
			<STable
				ref="dataTable"
				:columns="columnsData"
				:data="listData"
				:loading="loading"
				:row-key="'keyId'"
				@get-data="getMessageListData"
				@changeSelection="handleSelectionChange"
			>
				<!-- 标题（超链接，点击进入详情） -->
				<template #title>
					<el-table-column prop="title" label="标题" width="180" show-overflow-tooltip>
						<template #default="scope">
							<span class="down_btn" @click.stop="seeDetail(scope.row)">{{ scope.row.title }}</span>
						</template>
					</el-table-column>
				</template>
				<!-- 发送人 -->
				<template #sendUser>
					<el-table-column align="center" prop="sendUser" label="发送人" width="140">
						<template #default="scope">
							<span>{{ scope.row.sendUser ? scope.row.sendUser.value : "—" }}</span>
						</template>
					</el-table-column>
				</template>
				<!-- 状态 -->
				<template #isRead>
					<el-table-column align="center" prop="isRead" label="状态" width="90">
						<template #default="scope">
							<span>{{ scope.row.isRead == true ? "已读" : scope.row.isRead == false ? "未读" : "其他" }}</span>
						</template>
					</el-table-column>
				</template>
				<!-- 操作 -->
				<template #operation>
					<el-table-column align="center" label="操作" width="200" fixed="right">
						<template #default="scope">
						<div class="lcsj-row-actions"><el-tooltip content="已读" placement="top">
							<button class="lcsj-row-actions__link" v-if="scope.row.isRead == false" @click="clickReadMessage(scope.row)">标记已读</button>
							</el-tooltip>
							<el-tooltip content="删除" placement="top">
							<button class="lcsj-row-actions__link lcsj-row-actions__link--danger" @click="clickDeleteMessage(scope.row)">删除</button>
							</el-tooltip>
						</div>
					</template>
					</el-table-column>
				</template>
			</STable>

			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
			</div>

			<!-- 消息详情 -->
			<messageDetail v-if="activeTab === '2'" :param="param"></messageDetail>
		</topTab>
	</div>
</template>

<script>
import { GetMessageDataList, ReadMessage, DelMessage, ReadMessageBatch, DelMessageBatch } from "@/api/systemApi.js";
import messageDetail from "./messageDetail.vue";

export default {
	name: "SystemMessage",
	components: {
		messageDetail
	},
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "站内信"
				},
				{
					key: "2",
					value: "消息详情",
					isPush: true,
					isHide: true
				}
			],
			// 详情页参数
			param: {
				row: {}
			},
			pageShow: true,
			loading: false,
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				receiveUserId: "",
				isRead: "all"
			},
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			// 状态下拉项（含“全部”，不使用清空）
			stateList: [
				{ value: "all", name: "全部" },
				{ value: "unread", name: "未读" },
				{ value: "read", name: "已读" }
			],
			// 显示列
			columnsData: [],
			listColumns: [
				{ selection: true, width: "50", isKeep: true },
				{ index: true, label: "序号", width: "60", align: "center", isKeep: true },
				{ slot: "title", label: "标题", width: "180", isKeep: true },
				{ prop: "content", label: "内容", minWidth: "200" },
				{ slot: "sendUser", label: "发送人", width: "140", align: "center" },
				{ prop: "createTime", label: "发送时间", width: "200", align: "center" },
				{ slot: "isRead", label: "状态", width: "90", align: "center" },
				{ slot: "operation", label: "操作", width: "200", align: "center", fixed: "right" }
			],
			// 勾选中的消息 keyId
			opParams: []
		};
	},
	created() {
		let userdata = JSON.parse(localStorage.getItem("userdata"));
		this.formInline.receiveUserId = userdata.userInfo.keyId;
		this.columnsData = this.listColumns;
		this.getMessageListData();
	},
	methods: {
		// 顶部tab页面切换（切回列表时隐藏「消息详情」tab）
		changePages(tab) {
			this.activeTab = tab;
			switch (tab) {
				case "1":
					this.tabData[1].isHide = true;
					break;
				default:
					break;
			}
			this.$refs.topTab.showTopTab(this.tabData);
		},

		// 切到指定tab（index 为 tabData 下标）
		clickTab(index) {
			this.tabData[index].isHide = false;
			this.$refs.topTab.showTopTab(this.tabData);
			this.$refs.topTab.activeTabChange = index + 1 + "";
			this.changePages(index + 1 + "");
		},

		// 点击标题跳转消息详情（未读消息自动置为已读）
		seeDetail(row) {
			this.param.row = row;
			if (row.isRead == false) {
				ReadMessage({ keyId: row.keyId })
					.then((res) => {
						if (res.code === 1) {
							this.$root.Bus.$emit("message-refresh");
							this.getMessageListData();
						}
					})
					.catch((err) => {});
			}
			this.clickTab(1);
		},

		// 列表选中
		handleSelectionChange(val) {
			this.opParams = [];
			(val || []).forEach((item) => {
				this.opParams.push(item.keyId);
			});
		},

		// 批量已读
		batchRead() {
			if (this.opParams.length === 0) {
				this.$message.warning("请选择需要操作的数据！");
				return;
			}
			ReadMessageBatch({ keyIds: this.opParams })
				.then((res) => {
					if (res.code === 1) {
						this.$message.success("批量已读成功！");
						this.getMessageListData();
						this.$root.Bus.$emit("message-refresh");
					} else {
						this.$message.warning(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("操作失败，请稍后再试！");
				});
		},

		// 批量删除
		batchDelete() {
			if (this.opParams.length === 0) {
				this.$message.warning("请选择需要操作的数据！");
				return;
			}
			this.$confirm("确定要删除选中的消息吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				DelMessageBatch({ keyIds: this.opParams })
					.then((res) => {
						if (res.code === 1) {
							this.$message.success("删除成功！");
							this.getMessageListData();
							this.$root.Bus.$emit("message-refresh");
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},

		// 单条已读
		clickReadMessage(row) {
			let params = { keyId: row.keyId };
			ReadMessage(params)
				.then((res) => {
					if (res.code === 1) {
						this.$message.success("消息已读成功！");
						this.getMessageListData();
						this.$root.Bus.$emit("message-refresh");
					} else {
						this.$message.warning(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("操作失败，请稍后再试！");
				});
		},

		// 单条删除
		clickDeleteMessage(row) {
			this.$confirm("确定要删除这条消息吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let params = { keyId: row.keyId };
				DelMessage(params)
					.then((res) => {
						if (res.code === 1) {
							this.$message.success("删除成功！");
							this.getMessageListData();
							this.$root.Bus.$emit("message-refresh");
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},

		// 获取消息列表
		getMessageListData() {
			this.loading = true;
			let params = { ...this.formInline };
			// 状态下拉值映射为后端入参（全部 -> null）
			if (params.isRead === "unread") {
				params.isRead = false;
			} else if (params.isRead === "read") {
				params.isRead = true;
			} else {
				params.isRead = null;
			}
			GetMessageDataList(params)
				.then((res) => {
					if (res.code == 1 && res.data !== null) {
						this.listData = res.data;
						this.pageparm.pageIndex = this.formInline.pageIndex;
						this.pageparm.pageSize = this.formInline.pageSize;
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.pageparm.total = 0;
					}
				})
				.catch((err) => {
					this.$message.error("加载消息失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},

		// 分页事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getMessageListData();
		},

		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getMessageListData();
		}
	}
};
</script>

<style scoped>
.userRole {
	width: 100%;
}
/* 行内操作文字链（由表格操作列改造脚本注入） */
.lcsj-row-actions {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	white-space: nowrap;
}

.lcsj-row-actions__link {
	color: var(--app-primary-text);
	cursor: pointer;
	font-size: var(--app-font-base);
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;
	line-height: 1.6;
}

.lcsj-row-actions__link:hover {
	text-decoration: underline;
}

.lcsj-row-actions__link--danger {
	color: var(--app-danger-text);
}
</style>
